import { ArrowRight, Feather, Shell, Star, Waves } from 'lucide-react';
import { Link } from 'react-router-dom';
import CtaBand from '../components/CtaBand';

export default function Accueil() {
  return (
    <>
      <section className="home-hero">
        <div className="container-wide hero-grid">
          <div className="hero-copy">
            <span className="eyebrow">Lectrice · Correctrice</span>
            <div className="mini-wave" />
            <h1>Des mots justes<br />pour vos <em>histoires.</em></h1>
            <div className="shell-rule"><Shell size={28} /><span /></div>
            <p>J’accompagne vos écrits avec bienveillance pour en révéler tout le potentiel, dans le respect de votre voix et de votre intention.</p>
            <Link className="button button-primary" to="/prestations">Découvrir mes prestations <Waves size={18} /></Link>
          </div>
          <div className="hero-photo" role="img" aria-label="Livres, tasse et fleurs au bord de la mer" />
        </div>
      </section>

      <section className="values-bar">
        <div className="container-wide values-grid">
          <article><Shell /><div><h3>Bienveillance</h3><p>Un regard respectueux et constructif</p></div></article>
          <article><Feather /><div><h3>Expertise</h3><p>Un regard précis sur le fond et la forme</p></div></article>
          <article><Waves /><div><h3>Sur-mesure</h3><p>Un accompagnement adapté à vos besoins</p></div></article>
          <article><Star /><div><h3>Passion</h3><p>Parce que chaque histoire mérite d’être lue</p></div></article>
        </div>
      </section>

      
      <section className="home-seo container-wide">
        <div className="home-seo-copy">
          <span className="eyebrow eyebrow-clay">
            Mes prestations
          </span>

          <h2>Correction et relecture de manuscrits</h2>

          <p>
            Vous avez terminé votre roman, votre nouvelle ou votre
            manuscrit et souhaitez lui offrir un regard extérieur ?
            Vague de Mots vous accompagne dans la relecture,
            l’analyse et la correction de vos textes, avec rigueur
            et bienveillance.
          </p>

          <p>
            De la première lecture à la correction orthographique,
            chaque accompagnement respecte votre style, votre voix
            et les intentions qui donnent vie à votre histoire.
          </p>

          <Link className="text-link" to="/prestations">
            Découvrir mes prestations
            <ArrowRight size={18} />
          </Link>
        </div>
      </section>


      <section className="about-home container-wide">
        <img className="portrait-card" src="/assets/photo-marjorie.jpg" alt="Marjorie écrit dans un carnet" />
        <div className="about-copy">
          <span className="eyebrow eyebrow-clay">Qui suis-je ?</span>
          <h2>Une lectrice-correctrice<br />à vos côtés</h2>
          <div className="mini-wave" />
          <p>Passionnée par les mots sous toutes leurs formes, j’accompagne celles et ceux qui souhaitent porter un regard attentif sur leurs écrits et leur donner toute leur force.</p>
          <p>Parce que chaque texte possède sa singularité, je vous accompagne avec bienveillance et rigueur pour le faire évoluer, tout en respectant votre voix, votre style et votre intention.</p>
          <Link className="text-link" to="/presentation">Découvrir mon histoire <ArrowRight size={18} /></Link>
          <div className="round-signature"><Feather /><span>Rigueur & sensibilité</span></div>
        </div>
      </section>

      <CtaBand title="Faisons voguer vos mots un peu plus loin." text="Discutons de votre projet." />
    </>
  );
}
